import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { Checkbox, Button, Form, Input, Typography, Space } from 'antd';
import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { login, verifyLogin } from '../services/User';
const { Text, Link } = Typography;


export default () => {
    const [error, setError] = useState("");
    const [form] = Form.useForm();
    let nav = useNavigate();

    const onFinish = async (values: any) => {
        values.client = "pc"
        try {
            let token = await login(values);

            let config = {
                rember: form.getFieldValue("rember"),
                username: values.username,
                token,
                password: values.password
            }
            localStorage.setItem("accountInfo", JSON.stringify(config));
            nav("/home", { replace: true });

        } catch (e: any) {

            setError(e.toString());
        }

    };

    useEffect(() => {
        document.title = "管理服务器"
    }, [])

    const changeRemember = (e: any) => {
        let isRember = 0;
        if (e.target.checked == true) {
            isRember = 1;
        }
        console.log("onchange", isRember);
    }

    useEffect(() => {

        let account = localStorage.getItem("accountInfo");
        console.log("check 1", account);
        if (account != null) {


            try {
                let objAccount = JSON.parse(account);


                if (objAccount != null && objAccount.rember == true) {
                    console.log("setFieldsValue", objAccount)
                    form.setFieldsValue(objAccount);
                    // let loginParams: API.LoginParams = objAccount
                    // if (objAccount.token && objAccount.token != "") {
                    //     login(loginParams).then((v) => {
                    //         nav("/", { replace: true });
                    //     });
                    // }
                }
            } catch (e) {
                console.log(e)
            }



        }
    }, [])



    const onFinishFailed = (errorInfo: any) => {
        console.log('Failed:', errorInfo);
    };

    return (

        <div className="container">            
            <Form
                className="login-form"
                name="basic"
                form={form}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
            >
                <div id="title" className="title" >中控管理服务器</div>

                {error !== "" && (
                    <Text type="danger">{error}</Text>

                )}
                <Form.Item
                    name="username"

                    rules={[
                        {
                            required: true,
                            message: '请输入用户名!',
                        },
                    ]}
                >
                    <Input prefix={<UserOutlined className="site-form-item-icon" />} size="large" placeholder="用户名" />
                </Form.Item>

                <Form.Item
                    name="password"
                    rules={[
                        {
                            required: true,
                            message: '密码不能为空!',
                        },
                    ]}
                >
                    <Input
                        prefix={<LockOutlined className="site-form-item-icon" />}
                        type="password"
                        size="large"
                        placeholder="口令"
                    />
                </Form.Item>

                <Form.Item>
                    <Form.Item
                        name="rember"
                        valuePropName="checked"
                        noStyle

                    >
                        <Checkbox onChange={changeRemember} style={{ color: "white" }}>记住密码</Checkbox>
                    </Form.Item>

                </Form.Item>



                <Form.Item>
                    <Button type="primary" htmlType="submit" size="large" className='login-form-button'>
                        登录
                    </Button>
                </Form.Item>
            </Form>
            <div className="footer">华盛星晖（北京）科技有限公司</div>
        </div>
    )
}